/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Patient API
 * API for Patient
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PatientReceiptCodeTypename = "PatientReceiptCode" as const;

/**
 *
 * @export
 * @interface PatientReceiptCode
 */
export interface PatientReceiptCode {
  /**
   *
   * @type {number}
   * @memberof PatientReceiptCode
   */
  pharmacyId: number;
  /**
   *
   * @type {string}
   * @memberof PatientReceiptCode
   */
  receiptCode: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PatientReceiptCode
   */
  readonly __typename?: string;
}

export function PatientReceiptCodeFromJSON(json: any): PatientReceiptCode {
  return PatientReceiptCodeFromJSONTyped(json, false);
}

export function PatientReceiptCodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatientReceiptCode {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PatientReceiptCodeTypename,

    pharmacyId: json["pharmacy_id"],
    receiptCode: json["receipt_code"],
  };
}

export function PatientReceiptCodeToJSON(object?: PatientReceiptCode | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    pharmacy_id: value.pharmacyId,
    receipt_code: value.receiptCode,
  };
}
